// extracted by mini-css-extract-plugin
export default {"list":"list__Uf78h","item":"item__VDr8E","delete":"delete__hJAw5"};